<template>
  <div>
    <v-text-field
      label="Nome"
      v-model="fields.name.value"
      :rules="fields.name.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="Apelido"
      v-model="fields.nickname.value"
      :rules="fields.nickname.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="Telefone"
      v-model="fields.phone.value"
      :rules="fields.phone.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="E-mail"
      v-model="fields.email.value"
      :rules="fields.email.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="Documento pessoal"
      v-model="fields.person_document.value"
      :rules="fields.person_document.rules"
      type="text"
      outlined dense
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'userForm',
  data: () => ({
    fields: {
      name: {
        value: '',
        rules: []
      },
      nickname: {
        value: '',
        rules: []
      },
      phone: {
        value: '',
        rules: []
      },
      email: {
        value: '',
        rules: []
      },
      person_document: {
        value: '',
        rules: []
      }
    }
  }),
  computed: {
    ...mapGetters(['searchParams']),
    formParams () {
      return this.searchParams('customers')
    }
  },
  watch: {
    fields: {
      handler (val) {
        this.$emit('datachange', this.fields)
      },
      deep: true
    },
    formParams: {
      handler (val) {
        for (let key in val) {
          if (this.fields[key] && this.fields[key] !== val[key]) this.fields[key].value = val[key]
        }
      },
      deep: true
    }
  },
  mounted () {
    for (let key in this.searchParams('customers')) {
      if (this.fields[key] && this.fields[key] !== this.searchParams('customers')[key]) this.fields[key].value = this.searchParams('customers')[key]
    }
  }
}
</script>
